import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import SimulationProvider from "./hooks/useSimulation";
import Principal from "./components/Principal";


export const PageSimulation = () => {
    const [searchParams] = useSearchParams();
    const [projectName] = useState(searchParams.get("name"));
    const [clickupSpace] = useState(searchParams.get("project"));

    return (
        <SimulationProvider>
            <Principal clickupSpace={clickupSpace} projectName={projectName} />
        </SimulationProvider>
    );
};
